import { SystemsDecorator } from "../../modules/systems";
import { Store } from "./Store";

export const StoreContainer = () => {
  return (
    <SystemsDecorator>
      {(system) => <Store siteId={system.siteId} systemId={system.id} />}
    </SystemsDecorator>
  );
};
